import { render, staticRenderFns } from "./edit-material-modal.vue?vue&type=template&id=2e82c668&scoped=true"
import script from "./edit-material-modal.vue?vue&type=script&lang=js"
export * from "./edit-material-modal.vue?vue&type=script&lang=js"
import style0 from "./edit-material-modal.vue?vue&type=style&index=0&id=2e82c668&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e82c668",
  null
  
)

export default component.exports